"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskRequests = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const IndexUtils_1 = require("./IndexUtils");
const helpers_1 = require("./IndexUtils/helpers");
const Schedules_1 = require("./IndexUtils/helpers/Schedules");
const IndexApiProfileRequestTypes_1 = require("./Types/IndexApiProfileRequestTypes");
class TaskRequests {
    constructor(session, profileId, deakoOptions) {
        this.session = session;
        this.profileId = profileId;
        this.deakoOptions = deakoOptions;
    }
    getNextGen2DeviceMeshId(deviceType) {
        return __awaiter(this, void 0, void 0, function* () {
            const gen2DeviceMeshIdHandleTask = {
                type: Paths_1.TaskTypes.ADD_HANDLE_V1,
                argument: {
                    profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                    type: deviceType,
                    scope: Paths_1.Scopes.MESH,
                },
            };
            const gen2DeviceNextMeshIdRequest = {
                method: Paths_1.Methods.POST,
                body: gen2DeviceMeshIdHandleTask,
            };
            return this.makeRequest(gen2DeviceNextMeshIdRequest);
        });
    }
    createSimpleDevice(deviceReqInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                type: Paths_1.TaskTypes.ADD_SIMPLE,
                argument: Object.assign({ profileId: Paths_1.UuidPrefixes.profileId + this.profileId }, deviceReqInfo),
            };
            const addDeviceRequest = {
                method: Paths_1.Methods.POST,
                body,
            };
            return this.makeRequest(addDeviceRequest);
        });
    }
    createGen2Device(deviceReqInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                type: Paths_1.TaskTypes.ADD_DEVICE_V2,
                argument: Object.assign({ profileId: Paths_1.UuidPrefixes.profileId + this.profileId }, deviceReqInfo),
            };
            const addDeviceRequest = {
                method: Paths_1.Methods.POST,
                body,
            };
            return this.makeRequest(addDeviceRequest);
        });
    }
    createGen1Device(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { downstream, dimmable } = opts;
            const createRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.ADD_GEN1_SWITCH_V1,
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        dimmable,
                        downstream,
                    },
                },
            };
            return this.makeRequest(createRequest);
        });
    }
    createLoad(primaryDeviceId, deviceIds, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                type: Paths_1.TaskTypes.ADD_DEVICE_V2,
                argument: {
                    profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                    type: IndexApiProfileRequestTypes_1.IndexAPIDeviceType.LOAD,
                    name,
                    model: {
                        primaryDeviceId,
                        deviceIds: (0, helpers_1.keyIds)(deviceIds),
                    },
                },
            };
            const addLoadRequest = {
                method: Paths_1.Methods.POST,
                body,
            };
            return this.makeRequest(addLoadRequest);
        });
    }
    removeGen2Device(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const removeGen2DeviceRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.REMOVE_DEVICE_V1,
                    argument: {
                        id: uuid,
                    },
                },
            };
            return this.makeRequest(removeGen2DeviceRequest);
        });
    }
    removeGen1Switch(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const removeRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.DELETE_GEN1_SWITCH_V1,
                    argument: {
                        id,
                    },
                },
            };
            return this.makeRequest(removeRequest);
        });
    }
    createIndexZone(name, loadDeviceIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const deviceIds = (0, helpers_1.keyIds)(loadDeviceIds);
            const addIndexZoneRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.ADD_DEVICE_V2,
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        type: IndexApiProfileRequestTypes_1.IndexAPIDeviceType.ZONE,
                        name,
                        model: {
                            deviceIds,
                        },
                    },
                },
            };
            return this.makeRequest(addIndexZoneRequest);
        });
    }
    editZone(zoneId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const deviceIds = (0, helpers_1.keyIds)(options.loadDeviceIds);
            const editZoneTask = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_DEVICE_V1,
                    argument: {
                        id: zoneId,
                        properties: {
                            name: options.name,
                            model: lodash_1.default.isEmpty(deviceIds) ? undefined : { deviceIds },
                        },
                    },
                },
            };
            return this.makeRequest(editZoneTask);
        });
    }
    createIndexScene(name, model, actions) {
        return __awaiter(this, void 0, void 0, function* () {
            const addSceneTask = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.ADD_DEVICE_V2,
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        type: IndexApiProfileRequestTypes_1.IndexAPIDeviceType.SCENE,
                        name,
                        model,
                        actions,
                    },
                },
            };
            return this.makeRequest(addSceneTask);
        });
    }
    editIndexScene(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id, name, model, actions, } = opts;
            const editSceneTask = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_DEVICE_V1,
                    argument: {
                        id,
                        properties: {
                            name,
                            model,
                            actions,
                        },
                    },
                },
            };
            return this.makeRequest(editSceneTask);
        });
    }
    createSchedule({ days, start, end }) {
        return __awaiter(this, void 0, void 0, function* () {
            const addScheduleTask = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.ADD_SCHEDULE_V2,
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        start,
                        end,
                        days,
                    },
                },
            };
            const response = yield this.makeRequest(addScheduleTask);
            const schedule = Object.values(response.result.added.schedules).shift();
            if (schedule === undefined) {
                throw new Error("Schedule can't be undefined in the response");
            }
            const deviceEdited = Object.values(response.result.edited.devices).shift();
            if (deviceEdited === undefined) {
                throw new Error("Device edited can't be undefined in response");
            }
            return (0, Schedules_1.createScheduleFromAPI)(schedule, deviceEdited);
        });
    }
    deleteSchedule(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleteScheduleRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.DELETE_SCHEDULE_V2,
                    argument: { id },
                },
            };
            return this.makeRequest(deleteScheduleRequest);
        });
    }
    updateDevice(uuid, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const updateDeviceRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_DEVICE_V1,
                    argument: {
                        id: uuid,
                        properties: Object.assign({}, options),
                    },
                },
            };
            return this.makeRequest(updateDeviceRequest);
        });
    }
    updateSwitchKebabValue(id, showKebab) {
        return __awaiter(this, void 0, void 0, function* () {
            const updateSwitchRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_DEVICE_V1,
                    argument: {
                        id,
                        properties: {
                            showKebab,
                        },
                    },
                },
            };
            return this.makeRequest(updateSwitchRequest);
        });
    }
    updateRelayRoleRequest(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.updateRoleRequest(uuid, IndexApiProfileRequestTypes_1.DeviceRoleType.RELAY);
        });
    }
    addMatterRoleRequest(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.updateRoleRequest(uuid, IndexApiProfileRequestTypes_1.DeviceRoleType.MATTER);
        });
    }
    inviteUser({ email, role, emailContext }) {
        return __awaiter(this, void 0, void 0, function* () {
            const cleanedEmail = email.trim();
            const inviteRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.INVITE_V1,
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        email: cleanedEmail,
                        emailContext,
                        role,
                        emailTemplate: Paths_1.InviteTemplates.INVITE_V2,
                    },
                },
            };
            return this.makeRequest(inviteRequest);
        });
    }
    editProfile(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const editRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: Object.assign({ profileId: Paths_1.UuidPrefixes.profileId + this.profileId }, opts),
                    type: Paths_1.TaskTypes.EDIT_PROFILE_V1,
                },
            };
            return this.makeRequest(editRequest);
        });
    }
    editMembership(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { sub, role } = opts;
            const editRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        sub,
                        role,
                    },
                    type: Paths_1.TaskTypes.EDIT_MEMBERSHIP_V1,
                },
            };
            return this.makeRequest(editRequest);
        });
    }
    editMembershipV2(user, args) {
        return __awaiter(this, void 0, void 0, function* () {
            const sub = Object.values(user.identities)[0].sub;
            const editRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        sub,
                        role: args.role,
                    },
                    type: Paths_1.TaskTypes.EDIT_MEMBERSHIP_V1,
                },
            };
            return this.makeRequest(editRequest);
        });
    }
    deleteMembership(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { sub } = opts;
            const deleteRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        sub,
                    },
                    type: Paths_1.TaskTypes.DELETE_MEMBERSHIP_V1,
                },
            };
            return this.makeRequest(deleteRequest);
        });
    }
    deleteMembershipV2(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const sub = Object.values(user.identities)[0].sub;
            const removeRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        profileId: Paths_1.UuidPrefixes.profileId + this.profileId,
                        sub,
                    },
                    type: Paths_1.TaskTypes.DELETE_MEMBERSHIP_V1,
                },
            };
            return this.makeRequest(removeRequest);
        });
    }
    updateRoleRequest(uuid, role) {
        return __awaiter(this, void 0, void 0, function* () {
            const updateRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_DEVICE_V1,
                    argument: {
                        id: uuid,
                        properties: {
                            roles: [{ type: role }],
                        },
                    },
                },
            };
            return this.makeRequest(updateRequest);
        });
    }
    makeRequest(requestToMaket) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, requestToMaket, this.deakoOptions);
            const endpoint = (0, IndexUtils_1.getProfilesTaskEndpoint)(this.session, this.profileId);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
}
exports.TaskRequests = TaskRequests;
//# sourceMappingURL=TaskRequests.js.map